export var DynamicStats;
(function (DynamicStats) {
    DynamicStats["CoveragesGroup"] = "coverages-group";
    DynamicStats["SapioRatingHistory"] = "sapio-rating-history";
    DynamicStats["InsistencesGroup"] = "insistences-group";
    DynamicStats["InsistencesGroupHistory"] = "insistences-group-history";
    DynamicStats["CoverRequestsGroupHistory"] = "cover-requests-group-history";
})(DynamicStats || (DynamicStats = {}));
